import { AnnotationActivationMessage, Response, ErrorResponse, AnnotationReleaseMessage, AnnotationReleaseResponse } from '@augloop/session-protocol';

import { AnnotationActivationToken, AnnotationActivationOptions, IAnnotationActivationResult } from './isession';
import { ISessionManager } from './websocket/isession-manager';

export class AnnotationActivationTracker {
    private static nextActivationResultBatchId: number = 1;

    public readonly token: AnnotationActivationToken;
    public readonly annotationType: string;
    public readonly options: AnnotationActivationOptions;

    private promise: Promise<IAnnotationActivationResult>;
    private resolve: (value?: IAnnotationActivationResult) => void;
    private reject: (reason?: any) => void;
    private isComplete: boolean;
    private sessionManager: () => ISessionManager;

    public constructor(sessionManager: () => ISessionManager, annotationType: string, options?: AnnotationActivationOptions) {
        this.sessionManager = sessionManager;
        this.annotationType = annotationType;
        this.options = options;
        this.token = `${annotationType}-${AnnotationActivationTracker.nextActivationResultBatchId++}`;

        this.promise = new Promise<IAnnotationActivationResult>((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }

    public asPromise(): Promise<IAnnotationActivationResult> {
        return this.promise;
    }

    public activate(ignoreExistingAnnotations: boolean): void {
        this.sessionManager().sendMessage(new AnnotationActivationMessage({
            annotationType: this.annotationType,
            token: this.token,
            config: this.options ? this.options.config : undefined,
            ignoreExistingAnnotations: ignoreExistingAnnotations,
            sendStateUpdates: this.options ? !!this.options.stateUpdateCallback : undefined
        }), (error: ErrorResponse, _response: Response) => {
            this.complete(error ? new Error(error.error) : undefined);
        });
    }

    public release(): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.sessionManager().sendMessage(new AnnotationReleaseMessage({ token: this.token }), (error: ErrorResponse, response: AnnotationReleaseResponse) => {
                if (error) {
                    reject(new Error(error.error));
                } else {
                    resolve(response.lastRelease);
                }
            });
        });
    }

    private complete(error?: Error): void {
        if (this.isComplete) {
            return;
        }
        this.isComplete = true;
        if (error) {
            this.reject(error);
        } else {
            this.resolve({
                token: this.token
            });
        }
    }
}

